import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export type GetMerchantFinancialDocumentExternalRequest = {
  merchantId: string;
  year: string;
  posType: number;
  month: string;
};

async function getMerchantFinancialDocumentsExternal(
  data: GetMerchantFinancialDocumentExternalRequest
): Promise<any> {
  try {
    return (await axiosInstance.post("/Transaction/VPOSDocumentRequestForMerchant", data)).data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetMerchantFinancialReportExternal() {
  return useMutation<BaseResponse<Array<any>>, Error, GetMerchantFinancialDocumentExternalRequest>((variables) =>
    getMerchantFinancialDocumentsExternal(variables)
  );
}